import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardBody,
	Table,
	Row,
	Col,
	Input,
	FormGroup,
	Button
} from "reactstrap";

import { CATEGORY_REPORT } from '../../configs/urls'
import Loader from '../../components/Loader'
import { getApi } from '../../services/api'

import * as moment from 'moment';
import { PAGE_LIMIT, MESSAGES, DATE_FORMATS, REPORT_DATE_TYPES, APPLICATION_STATUS, APPLICATION_KEYS } from '../../configs/constant'
import DatePicker from 'reactstrap-date-picker'
import exportFromJSON from 'export-from-json'
import { useHistory } from 'react-router-dom'

import './styles.css'
const Report = () => {

	const [isRequesting, setIsRequestig] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false);
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
		from_date: moment().subtract(1, 'month').toISOString(),
		to_date:  moment().toISOString()
	})
	const [reportData, setReportData] = useState([])

	const [selectedDateType, setSelectedDateType] = useState(REPORT_DATE_TYPES[0])

	const history = useHistory()

	useEffect(() => {
		getAllData(false, true);
	}, []);

	const getAllData = (isLoadMore, isInitialLoad) => {
		isInitialLoad ? setIsRequestig(true) : setIsLoading(true);
		const params = filterParams;

		if(!params.from_date) {
			delete params.from_date
		} else {
			params.from_date = moment(params.from_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}

		if(!params.to_date) {
			delete params.to_date
		} else {
			params.to_date = moment(params.to_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}

		getApi(CATEGORY_REPORT, params).then(res => {
			let reports = isLoadMore ? [...reportData, ...res.data] : res.data;
			setReportData(reports || []);
			setCanShowLoadMore(reports.length < res.meta.total)
		}).catch(() => {}).finally(() => {
			isInitialLoad ? setIsRequestig(false) : setIsLoading(false);
		})
	};

	const resetFilter = () => {
		setFilterParams({
			from_date: moment().subtract(1, 'month').toISOString(),
			to_date:  moment().toISOString(),
			name: '',
			page: 0,
			size: PAGE_LIMIT
		})

		setSelectedDateType(REPORT_DATE_TYPES[0])

		getAllData();
	}

	const searchReports = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		getAllData();
	}

	const loadMoreReport = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		getAllData(true);
	}

	const setSelectedDateTypeAndGetData = (e) => {
		const dateType = REPORT_DATE_TYPES.find(type => type.id == e.target.value)
		setSelectedDateType(dateType);
		
		if(e.target.value != 4) {
			setFilterParams({
				...filterParams,
				from_date: moment().subtract(dateType.month, 'month').toISOString(),
				to_date: moment().toISOString()
			})
		}
	}

	const viewApplications = (category, applicationStatus) => {
		applicationStatus ? history.push(`/admin/application?category_id=${category.id}&status=${applicationStatus}`) : history.push(`/admin/application?category_id=${category.id}`)
	}

	const exportToExcel = () => {
		setIsLoading(true)
		const params = JSON.parse(JSON.stringify(filterParams));

		if(!params.from_date) {
			delete params.from_date
		} else {
			params.from_date = moment(params.from_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}

		if(!params.to_date) {
			delete params.to_date
		} else {
			params.to_date = moment(params.to_date).format(DATE_FORMATS.DATE_SERVER_FORMAT)
		}

		delete params.size
		delete params.page
		
		getApi(CATEGORY_REPORT, params).then(res => {
			const data = []
			res.data.map(value => {
				data.push({
					ID : value.id,
					CATEGORY: value.name,
					[`${APPLICATION_STATUS.TOTAL}`]: value.counts.total_applications,
					[`${APPLICATION_STATUS.ELIGBLE} APPLICATIONS`]: value.counts.eligible_applications,
					[`${APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED} APPLICATIONS`]: value.counts.not_eligible_applications,
					[`${APPLICATION_STATUS.PENDING_VERIFICATION} APPLICATIONS`]: value.counts.pending_applications,
					[`${APPLICATION_STATUS.BENIFIT_GIVEN} APPLICATIONS`] : value.counts.benefit_given_applications,
					[`${APPLICATION_STATUS.NOT_ELIGBLE_REJECTED} APPLICATIONS`] : value.counts.reject_applications,
					[`${APPLICATION_STATUS.RE_APPLIED} APPLICATIONS`] : value.counts.reapplied_applications
				})
			})

			const fileName = 'download'
			const exportType = 'csv'
			
			exportFromJSON({ data, fileName, exportType })
		}).catch(() => {}).finally(() => {
			setIsLoading(false);
		})
	}

	const renderReport = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<Card>
							<CardBody>
								<Row>
									<Col className="pr-1" md="3">
										<FormGroup>
											<label>Date type</label>
											<Input
												type="select"
												name="date_type"
												id="report-date-type"
												value={selectedDateType.id}
												onChange={(e) => setSelectedDateTypeAndGetData(e)}
											>
												{
													REPORT_DATE_TYPES.map(type => (
														<option key={type.id} value={type.id}>{type.label}</option>
													))
												}
											</Input>
										</FormGroup>
									</Col>
									<Col className="pr-1" md="3">
										<FormGroup>
											<label>From Date</label>
											<DatePicker
												dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
												value= {filterParams.from_date} 
												onChange= {(value, f) => {
													setFilterParams({...filterParams, from_date: value})
													setSelectedDateType(REPORT_DATE_TYPES[3]); // Setting custom option
												}} />
										</FormGroup>
									</Col>
									<Col className="pr-1" md="3">
										<FormGroup>
											<label>To Date</label>
											<DatePicker
												dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
												value= {filterParams.to_date} 
												onChange= {(value, f) => {
													setFilterParams({...filterParams, to_date: value})
													setSelectedDateType(REPORT_DATE_TYPES[3]); // Setting custom option
												}} />
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col className="pr-1" md="6">
										<div className="update ml-auto mt-3 mr-auto">
											<Button className="btn-round" onClick={() => searchReports()} color="primary">
												Search
											</Button>
											<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
												Reset
											</Button>
											<Button className="btn-round ml-2" onClick={() => exportToExcel()} color="primary">
												Export
											</Button>
										</div>
									</Col>
								</Row>
							</CardBody>
						</Card>
						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>S.No.</th>
										<th>Category</th>
										<th>{APPLICATION_STATUS.TOTAL}</th>
										<th>{`${APPLICATION_STATUS.ELIGBLE} applications`}</th>
										<th>{`${APPLICATION_STATUS.ELIGBLE_BUT_NOT_ASSITED} applications`}</th>
										<th>{`${APPLICATION_STATUS.PENDING_VERIFICATION} applications`}</th>
										<th>{`${APPLICATION_STATUS.BENIFIT_GIVEN} applications`}</th>
										<th>{`${APPLICATION_STATUS.NOT_ELIGBLE_REJECTED} applications`}</th>
										<th>{`${APPLICATION_STATUS.RE_APPLIED} applications`}</th>
									</tr>
								</thead>
								<tbody>
									{
										reportData.map((categoryReport, idx) => (
											<tr key={idx}>
												<td>{idx + 1}</td>
												<td 
													className="cursor-pointer"
												 	onClick={() => viewApplications(categoryReport)}>
													 {categoryReport.name || '--'}
												</td>
												
												<td
													className="cursor-pointer"
													onClick={() => viewApplications(categoryReport)}>
														{categoryReport.counts.total_applications}
												</td>
												
												<td 
													className="cursor-pointer"
													onClick={() => viewApplications(categoryReport, APPLICATION_KEYS.ELIGBLE)}>
														{categoryReport.counts.eligible_applications}
												</td>
												
												<td
													className="cursor-pointer"
													onClick={() => viewApplications(categoryReport, APPLICATION_KEYS.ELIGBLE_BUT_NOT_ASSITED)}>
														{categoryReport.counts.not_eligible_applications}
												</td>
												
												<td
													className="cursor-pointer"
													onClick={() => viewApplications(categoryReport, APPLICATION_KEYS.PENDING_VERIFICATION)}>
														{categoryReport.counts.pending_applications}
												</td>
												
												<td
													className="cursor-pointer"
													onClick={() => viewApplications(categoryReport, APPLICATION_KEYS.BENIFIT_GIVEN)}>
														{categoryReport.counts.benefit_given_applications}
												</td>
												
												<td
													className="cursor-pointer"
													onClick={() => viewApplications(categoryReport, APPLICATION_KEYS.NOT_ELIGBLE_REJECTED)}>
														{categoryReport.counts.reject_applications}
												</td>
												
												<td>{categoryReport.counts.reapplied_applications}</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								reportData.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreReport()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderReport()
			}
		</>
	);
}

export default Report;
